import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {// catches all bad routes and redirects to '/'
   // for deployment, it loads index.html which shows blank page
   // instead of loading index.html, it should redirect to '/'
    path: '*',
    name: 'catchAll',
    redirect: "/" 
  },
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue')
  },
  {
    path: '/:chapterName/:pageNumber',
    name: "Comic-Page",
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue'),
    meta: {
      title: 'About KotWC'
    }
  },
  {
    path: '/archives',
    name: 'Archive',
    component: () => import('../views/Archive.vue'),
    meta: {
      title: 'KotWC Chapter Archives'
    }
  },
  {
    path: '/lunythecreator',
    name: 'Login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/gallery',
    name: 'Gallery',
    component: () => import('../views/Gallery.vue'),
    meta: {
      title: 'KotWC Art Gallery'
    }
  },
  {
    path: '/managecomic',
    name: 'ManageComic',
    component: () => import('../views/ManageComic.vue'),
    meta: {
      requiresAuth: true,
    }
  },
  {
    path: '/managegallery',
    name: 'ManageGallery',
    component: () => import('../views/ManageGallery.vue'),
    meta: {
      requiresAuth: true,
    }
  },
  {
    path: '/managebanners',
    name: 'ManageBanners',
    component: () => import('../views/ManageBanners.vue'),
    meta: {
      requiresAuth: true,
    }
  },
  {
    path: '/:chapterName',
    name: "Comic-Strip",
    component: Home
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach((toRoute, fromRoute, next)=>{
  if(toRoute.name == "Comic-Page" || toRoute.name == "Comic-Strip"){
    if(toRoute.params.pageNumber)
      window.document.title = "Ch " +  toRoute.params.chapterName.split("chapter")[1] + ", P " + toRoute.params.pageNumber;
    else
      window.document.title = "Ch " +  toRoute.params.chapterName.split("chapter")[1];
  }
  else{
    window.document.title = toRoute.meta && toRoute.meta.title ? toRoute.meta.title : 'Knights of the Wandering Castle';
  }
  next();
})

export default router
